'use strict';
import {stateGo} from 'redux-ui-router';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/takeUntil';
import {selectedOrganization} from '../../app/model/actions';
import {navStates} from '../../app/router';
import {getLink} from '../../core-utilities/domain/ReduxUtils';
import {userStates} from '../../user/router-config';
import {logger} from './logger';


InvitationRespondController.$inject = [
  '$scope',
  '$ngRedux',
  '$stateParams',
  '$ionicViewSwitcher',
  'OrganizationInviteAccessCodeDomain',
  'UserInviteDomain',
  'UserPreferenceDomain',
  'currentUser',
];

// TODO: we need to break up invite retrieval and user association. We need to give the user a chance to confirm that are logged in with right account first.
/* InvitationRespondController
 * template: ./invitation-respond.html
 */
export function InvitationRespondController(
  $scope,
  $ngRedux,
  $stateParams,
  $ionicViewSwitcher,
  OrganizationInviteAccessCodeDomain,
  UserInviteDomain,
  UserPreferenceDomain,
  currentUser,
) {
  const vm = this;

  vm.accept = accept;
  vm.reject = reject;
  vm.ignore = ignore;

  const states = {
    loading: {
      message: '',
      button: '',
      action: null,
    },
    'valid-code': {
      message: 'auth.invite.respond.later',
      button: 'auth.invite.respond.skip',
      action: escapeWizard,
    },
    'resent-invite': {
      message: 'auth.invite.resent.message',
      button: 'auth.invite.home.button',
      action: escapeWizard,
    },
    'expired-code': {
      message: 'auth.invite.expired.message',
      button: 'auth.invite.expired.button',
      action: requestNewCode,
    },
    'no-invite': {
      message: 'auth.invite.missing.message',
      button: 'auth.invite.home.button',
      action: escapeWizard,
    },
    'no-code': {
      message: 'auth.invite.no.code.message',
      button: 'auth.invite.home.button',
      action: escapeWizard,
    },
    'already-member': {
      message: 'auth.invite.member.message',
      button: 'auth.invite.home.button',
      action: escapeWizard,
    },
    error: {
      message: 'auth.invite.error.message',
      button: 'auth.invite.home.button',
      action: escapeWizard,
    },
  };

  init($stateParams.accessCode);

  function init(accessCode) {
    if (!accessCode) {
      changeMode('no-code');

    } else {
      vm.mode = 'loading';
      OrganizationInviteAccessCodeDomain.$get(accessCode)
        .then(invite => {
          if (!invite) {
            return {payload: {mode: 'no-invite'}};

          } else if (!inviteIsValid(invite)) {
            return {payload: {mode: 'expired-code'}, invite};

          } else {
            // testing temp
            // return {payload: {mode: 'valid-code'}, invite};
            return retrieveInvite(invite)
              .then((userInvite) =>
                !userInvite || !getLink(userInvite, 'organization').id
                  ? {payload: {mode: 'no-invite'}}
                  : checkIsMember(getLink(userInvite, 'organization').id)
                    .then(isMember => ({
                      payload: {
                        mode: isMember ? 'already-member' : 'valid-code',
                        invite,
                        userInvite,
                      },
                    }))
              );
          }
        })
        .catch(err => {
          if (err) {
            logger.error({err}, 'Failed to retrieve access code');
          }

          return {
            payload: {mode: 'error', err},
          };
        })
        .then((action) =>
          $scope.$evalAsync(() => {
            vm.invite = action.payload.invite;
            vm.userInvite = action.payload.userInvite;
            changeMode(action.payload.mode);
          })
        );
    }
  }

  function changeMode(mode) {
    logger.debug(`Switching to mode ${mode}`);
    vm.mode = mode;
    vm.message = states[mode].message;
    vm.action = states[mode].action;
    vm.button = states[mode].button;
  }

  function accept() {
    vm.userInvite.accept()
      .then(response => {
        logger.debug({response}, 'accept response');

        if (response.statusCode == 200 && response.organizationId) {
          $ngRedux.dispatch(selectedOrganization(response.organizationId));
        }

        $ionicViewSwitcher.nextDirection('forward');
        $ngRedux.dispatch(stateGo('setup-complete-org-invite-accepted'));
      })
      .catch(onError);
  }

  function reject() {
    vm.userInvite.reject()
      .then(response => {
        logger.debug('reject response:', response);

        $ionicViewSwitcher.nextDirection('forward');
        $ngRedux.dispatch(stateGo(navStates.orgsList));
      })
      .catch(onError);
  }

  // TODO: if the user just created an account, send them to the setup to prompt to create a new org. otherwise send to home screen
  //       maybe this check belongs in model. check user.organizations.size() and send to create org message if its 0
  //       would need to check pending invites as well and send to invites instead if there are any
  function ignore() {
    // for now, just escape the wizard
    escapeWizard();
  }

  function retrieveInvite(invite) {
    // TODO: do not automatically associate the user.
    // TODO: Allow the user to view their login credentials
    // TODO: Offer the user the choice to associate the invite with the currently logged in account
    // TODO: relevance of this choice is pending impl of viewing pending invites after you have logged in
    return invite.associateUser()
      .then(response => {
        console.log('invite.associateUser() ->', response);

        return UserInviteDomain.$get(response.inviteId);
      });
  }

  // its effectively expired if there are only 5 minutes left. Should account for small clock sync issues
  function inviteIsValid(invite) {
    return invite && invite.expires
      ? (invite.expires.getTime() - Date.now()) > 5 * 60 * 1000
      : false;
  }

  function checkIsMember(orgId) {
    return currentUser.isMemberOfOrg(orgId);
  }

  function requestNewCode() {
    if (vm.invite) {
      vm.invite.requestNewCode()
        .then(() => {
          changeMode('resent-invite');

        })
        .catch(err => {
          logger.error({err}, 'Failed to request a new code');

          if (err && err.statusCode === 404) {
            changeMode('no-invite');
          } else {
            changeMode('error');
          }
        });
    } else {
      logger.warn('requestNewCode: No invite. Should not happen');
      changeMode('error');
    }
  }

  function escapeWizard() {
    $ionicViewSwitcher.nextDirection('forward');
    $ngRedux.dispatch(stateGo(userStates.home));
  }

  function onError(error) {
    changeMode('error');
    logger.error({err: error});
  }
}



// WEBPACK FOOTER //
// ./src/js/auth/controllers/InvitationRespondController.js